import { useEffect, useState } from 'react';
import { getRemainingTimeUntil6AM } from '@/utils/getRemainingTimeUntil6Am';
import moment from 'moment';
import ClockIcon from '@/assets/icons/V3/ClockIcon.svg?react';
import { cn } from '@/utils/tailwind';

interface RemainingTime {
  hours: number;
  minutes: number;
}

export const NewsHeader = ({ date }: { date: string }) => {
  const formattedDate = moment(date).format('MM월 DD일');

  return (
    <div className="flex w-full items-center justify-between text-gr-900">
      <h2 className="Body1S16">{formattedDate} 이커머스 소식</h2>
      <NewsBadge />
    </div>
  );
};
export const NewsBadge = ({ isDashboard = false }) => {
  const [remainingTime, setRemainingTime] = useState<RemainingTime>(getRemainingTimeUntil6AM());

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime(getRemainingTimeUntil6AM());
    }, 60 * 1000); // 매 1분마다 갱신

    return () => clearInterval(interval);
  }, []);

  const { hours, minutes } = remainingTime;

  return (
    <div
      className={cn(
        'flex w-fit items-center gap-x-[4px] rounded-[4px] px-[4px] py-[2px] text-[12px] font-bold leading-[18px]',
        'bg-point-100 font-medium text-point-500',
      )}
    >
      <ClockIcon className="h-[16px] w-[16px] text-current" />
      {hours > 0 ? `${hours}시간 후 변경` : `${minutes}분 후 변경`}
    </div>
  );
};
